<template>
  <div class="_display:inline-flex">
    <a
      :href="url"
      class="flex items-center justify-center p-2 border border-transparent rounded-md shadow-sm text-white bg-[#0077B5] hover:bg-[#006699] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 _transition:all _transition-duration:200"
      :aria-label="ariaLabel"
      :class="{ '_width:14 _height:12 _padding-x:2': !label, '_py:2 _px:4': label }"
      :title="label || ariaLabel">
      <svg class="w-5 h-5" :class="{ 'mr-2': label }" fill="currentColor" viewBox="0 0 24 24">
        <path
          d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
      <span v-if="label" class="text-sm font-medium">{{ label }}</span>
    </a>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    label: {
      type: String,
      default: 'Continue with LinkedIn',
    },
    role: {
      type: String,
      default: '',
    },
  })

  const url = computed(() => {
    const baseUrl = route('auth.linkedin')
    return props.role ? `${baseUrl}?user_role=${props.role}` : baseUrl
  })

  const ariaLabel = computed(() => {
    if (props.role === 'student-user') {
      return 'Sign up with LinkedIn as Student'
    } else if (props.role === 'trial-user') {
      return 'Sign up with LinkedIn as Course Creator'
    }
    return 'Continue with LinkedIn'
  })
</script>
